module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-tooltip', {
    attrs: {
      "placement": "top",
      "effect": "light"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('img', {
    attrs: {
      "src": "/static/help/newsletter.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "info",
      "size": "mini"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle"
  }), _vm._v(" Pomocnicze informacje dotyczące grafik\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tła",
      "error": _vm.errors['bg_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.bg_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "bg_color", $$v)
      },
      expression: "form.bg_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Kolor tekstu",
      "error": _vm.errors['text_color']
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.form.text_color),
      callback: function($$v) {
        _vm.$set(_vm.form, "text_color", $$v)
      },
      expression: "form.text_color"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Lewy obrazek",
      "error": _vm.errors['left_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.left_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "left_image", $$v)
      },
      expression: "form.left_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prawy obrazek",
      "error": _vm.errors['right_image']
    }
  }, [_c('image-input-component', {
    model: {
      value: (_vm.form.right_image),
      callback: function($$v) {
        _vm.$set(_vm.form, "right_image", $$v)
      },
      expression: "form.right_image"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Opis",
      "error": _vm.errors[_vm.addLanguageSuffix('description')]
    }
  }, [_c('wyswig-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('description')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('description'), $$v)
      },
      expression: "form[addLanguageSuffix('description')]"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-430aae57"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/forms/NewsletterWidget.vue
// module id = 745
// module chunks = 0